import {
  inputPaddingsPxDefault,
  inputPaddingsPxWithButton,
  inputPaddingsPxWithIsClearable,
  inputPaddingsPxWithIsClearableAndButton,
  inputPaddingsRemDefault,
  inputPaddingsRemWithButton,
  inputPaddingsRemWithIsClearable,
  inputPaddingsRemWithIsClearableAndButton,
  inputSizes,
} from '@shared/config/components/input'

export const getInputPaddingsRem = (size: keyof typeof inputSizes, isClearable: boolean, buttonWidth: number) => {
  if (!isClearable && !buttonWidth) {
    return inputPaddingsRemDefault[size]
  }

  if (isClearable && !buttonWidth) {
    return inputPaddingsRemWithIsClearable[size]
  }

  if (!isClearable && buttonWidth) {
    return inputPaddingsRemWithButton(buttonWidth)[size]
  }

  return inputPaddingsRemWithIsClearableAndButton(buttonWidth)[size]
}

export const getInputPaddingsPx = (size: keyof typeof inputSizes, isClearable: boolean, buttonWidth: number) => {
  if (!isClearable && !buttonWidth) {
    return inputPaddingsPxDefault[size]
  }

  if (isClearable && !buttonWidth) {
    return inputPaddingsPxWithIsClearable[size]
  }

  if (!isClearable && buttonWidth) {
    return inputPaddingsPxWithButton(buttonWidth)[size]
  }

  return inputPaddingsPxWithIsClearableAndButton(buttonWidth)[size]
}
